import React, { memo } from 'react';

import { convertDateString } from '../../utils/dateFormat';

const DateRendererComponent = ({ value }) => <span>{convertDateString(value)}</span>;

export const DateRenderer = memo(DateRendererComponent);
